import type {Mapper} from 'framework';
import type {ActiveScheduleWorkout} from '../../domain/active-schedule-workout';
import type {ActiveWorkoutDto} from '../dto/schedule.dto';

/** The banner shows the live workout's name; nothing else of the workout is read. */
export class WorkoutDtoToActiveScheduleWorkoutMapper implements Mapper<
  ActiveWorkoutDto,
  ActiveScheduleWorkout
> {
  transform(dto: ActiveWorkoutDto): ActiveScheduleWorkout {
    return {id: dto.id, name: dto.name};
  }
}
